import { render, staticRenderFns } from "./AddCoursesToEmployee.vue?vue&type=template&id=3214fb5e"
import script from "./AddCoursesToEmployee.vue?vue&type=script&lang=js"
export * from "./AddCoursesToEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports